import { MediaResponse } from "../../../models/media-model";
import { instance } from "../../../api";

export function resolveStrapiMediaUrl(
  media: MediaResponse | MediaResponse[] | null | undefined,
): string {
  const item = Array.isArray(media) ? media[0] : media;
  if (!item?.url) {
    return "";
  }

  if (item.url.startsWith("http")) {
    return item.url;
  }

  const base = instance.defaults.baseURL ?? "";
  return `${base}${item.url}`;
}

export function resolveStrapiMediaId(
  media: MediaResponse | MediaResponse[] | null | undefined,
): number | undefined {
  const item = Array.isArray(media) ? media[0] : media;
  return item?.id;
}
